export const ContactInfo = [
  {
    socialmedia: "Facebook",
    username: "Imène ALLOUCHE",
    link: "https://www.facebook.com/imene.alch.5/",
  },

  {
    socialmedia: "Instagram",
    username: "Imène ALLOUCHE",
    link: "https://www.instagram.com/imenealch/",
  },

  {
    socialmedia: "LinkedIn",
    username: "Imène ALLOUCHE",
    link: "https://www.linkedin.com/in/imene-allouche-045b21226/",
  },

  {
    socialmedia: "Discord",
    username: "Im3ne#6939",
    link: "https://discord.com/",
  },

  {
    socialmedia: "Email",
    username: "li_allouche@esi.dz",
    link: "https://mail.google.com/mail/u/0/#inbox",
  },

  {
    socialmedia: "GitHub",
    username: "imenealch",
    link: "https://github.com/Imeneallouche",
  },
  {
    socialmedia: "Medium",
    username: "Imène ALLOUCHE",
    link: "https://medium.com/@li_allouche",
  },
];
